import React from "react";
import styles from "./Spinner.module.css";
import type { spinnerProps } from "./types.props";

const LoadingSpinner: React.FC<spinnerProps> = ({
    size = "medium",
    text,
    className = "",
    isLoading = true,
}) => {
    if (!isLoading) return null;

    return (
        <div className={`${styles["spinner-container"]} ${className}`}>
            <div className={`${styles["spinner"]} ${styles[size]}`} />
            {text && <p className={styles["spinner-text"]}>{text}</p>}
        </div>
    );
};

export default LoadingSpinner;
